import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CredentialRenovationsService } from '@asambleas-services/credential-renovations.service';
import { CredentialRenovation } from '@asambleas-models/CredentialRenovation';
import { MatDialog } from '@angular/material';
import { InputTextComponent } from '@asambleas-components/input-text/input-text.component';
import { MinisterService } from '@asambleas-services/minister/minister.service';
import { ConfirmComponent } from '@asambleas-components/confirm/confirm.component';
import { UserFeedbackService } from '@asambleas-modules/user-feedback/user-feedback.service';

@Component({
  selector: 'app-see-credential-renovation',
  templateUrl: './see-credential-renovation.component.html',
  styleUrls: ['./see-credential-renovation.component.scss']
})
export class SeeCredentialRenovationComponent implements OnInit {

  credentialRenovation: CredentialRenovation;

  member;

  constructor(private activatedRoute: ActivatedRoute,
    private _credentialRenovationsService: CredentialRenovationsService,
    private _ministersService: MinisterService,
    private userFeedback: UserFeedbackService,
    private router: Router,
    private dialog: MatDialog) { }

  ngOnInit() {

    this.activatedRoute.params
      .subscribe((data: any) => {
        if (data.id) {
          this._credentialRenovationsService.getCredentialRenovation(data.id)
            .subscribe((response: CredentialRenovation) => {

              console.log(response);
              this.credentialRenovation = response;
              this.member = this.credentialRenovation.minister.user;
            })
        }
      })
  }

  revokeRequest() {
    const ref = this.dialog.open(InputTextComponent, {
      data: { title: 'Ingrese el motivo del rechazo de la solicitud', placeholder: 'Motivo' }
    });

    ref.afterClosed()
      .subscribe((data) => {
        if (data) {

          this._ministersService.setCredentialRequestStatus(this.credentialRenovation.id, { status: '04', description: data })
            .subscribe((response) => {

              this.userFeedback.openSnackbar({ message: 'Solicitud rechazada exitósamente' });
              this.router.navigate(['/admin', 'ministers', 'request-credential-renovation']);
            })
        }
      })
  }

  approveRequest() {
    const ref = this.dialog.open(ConfirmComponent, {
      data: { title: 'Aprobar solicitud', content: '¿Está seguro de aprobar la solicitud?', btnAgree: 'Aprobar', btnDisagree: 'Cancelar' }
    });

    ref.afterClosed()
      .subscribe((data: { return: boolean }) => {

        if (data.return) {

          this._ministersService.setCredentialRequestStatus(this.credentialRenovation.id, { status: '03' })
            .subscribe((response) => {

              this.userFeedback.openSnackbar({ message: 'Solicitud aprobada exitósamente' });
              this.router.navigate(['/admin', 'ministers', 'request-credential-renovation']);
            })
        }
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/pages/ministers/see-credential-renovation/see-credential-renovation.component.ts